import React, { createContext, FunctionComponent, ReactNode } from 'react';

import { GatsbyImageProps } from 'gatsby-plugin-image';

export type FluidImageProviderProps = {
  images?: {
    id?: string;
    localFile?: {
      childImageSharp?: {
        gatsbyImageData?: GatsbyImageProps['image'];
      };
    };
  }[];
  children: ReactNode;
};

export const FluidImageContext = createContext<FluidImageProviderProps['images']>([]);

const FluidImageProvider: FunctionComponent<FluidImageProviderProps> = (props) => {
  const { images, children } = props;

  return <FluidImageContext.Provider value={images}>{children}</FluidImageContext.Provider>;
};

export default FluidImageProvider;
